import type { CreateClientConfig } from './api/client.gen'
import { BACKEND_URL } from './services/supabase/env'

// Token management constants
const TOKEN_KEY = 'kinzship_access_token'

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    ...config?.headers,
    // Automatically include auth token if available
    get Authorization() {
      const token = localStorage.getItem(TOKEN_KEY)
      return token ? `Bearer ${token}` : undefined
    },
  },
})
